import React from 'react'

export const MergeIcon = () => {
  return (
    <svg
      width="14"
      height="12"
      viewBox="0 0 14 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.6667 9.33333L11 6.66667L11 8.65333C10.6608 8.64795 10.3477 8.62517 10.0712 8.59203C8.34715 8.37313 7.72839 7.68965 7.08 6.96667C6.82306 6.67469 6.54566 6.3776 6.19852 6.11123C6.14948 6.07338 6.09892 6.03626 6.04666 6C6.09892 5.96374 6.14948 5.92662 6.19852 5.88877C6.54566 5.6224 6.82306 5.32531 7.08 5.03333C7.72839 4.31035 8.34715 3.62687 10.0712 3.40797C10.3477 3.37483 10.6608 3.35205 11 3.34667L11 5.33333L13.6667 2.66667L11 -4.66255e-07L11 2.00667C10.6276 2.0164 10.2853 2.04174 9.96981 2.0804C9.82464 2.09709 9.68568 2.11689 9.55333 2.14L9.55372 2.14153C7.58217 2.4819 6.76674 3.38314 6.08667 4.14C6.03485 4.19769 5.98445 4.2538 5.93487 4.30821L5.93333 4.30667C5.36666 4.92667 4.90667 5.33333 3.66667 5.33333L0.333332 5.33333L0.333332 6.66667L3.66667 6.66667C4.90667 6.66667 5.36666 7.07333 5.93333 7.69333L5.93487 7.69179C5.98445 7.7462 6.03485 7.80231 6.08667 7.86C6.76674 8.61686 7.58217 9.5181 9.55372 9.85847L9.55333 9.86C9.68568 9.88311 9.82465 9.90291 9.96982 9.9196C10.2853 9.95826 10.6276 9.9836 11 9.99333L11 12L13.6667 9.33333Z"
        fill="#1B2B79"
      />
    </svg>
  )
}
